import React from "react";
import NavBar from "../components/homePage/navBar";
import CreateInventory from "../components/Inventories/CreateInventory"


const CreateInventoryPage: React.FC = () => {
    return (
        <div>
            <NavBar/>
            <CreateInventory />
        </div>
    )
}

export default CreateInventoryPage;